namespace Portico.Models.Enterprise {

    export interface ISurveySession {
        surveySessionId: number;
        surveyId: number;
        sourceSystemId: number;
        surveySourceId: number;
        surveySessionAnswers: SurveySessionAnswer[];

		getSurveySessionAnswers(questionId: number): SurveySessionAnswer[];
		isSurveySessionAnswer(questionId: number, answerId: number): boolean;
		setSurveySessionAnswers(questionId: number, answerIds: number[], answerValue: string): void;
	}

    export class SurveySession implements ISurveySession {
        surveySessionId: number;
        surveyId: number;
        sourceSystemId: number;
        surveySourceId: number;
        surveySessionAnswers: SurveySessionAnswer[];

        constructor(obj?: ISurveySession) {
            this.surveySessionId = null;
            this.surveyId = null;
            this.sourceSystemId = null;
            this.surveySourceId = null;
            this.surveySessionAnswers = [];

            if (obj) {
                this.surveySessionId = obj.surveySessionId || null;
				this.surveyId = obj.surveyId || null;
                this.sourceSystemId = obj.sourceSystemId || null;
                this.surveySourceId = obj.surveySourceId || null;

                if (obj.surveySessionAnswers) {
                    for (const surveySessionAnswer of obj.surveySessionAnswers) {
                        this.surveySessionAnswers.push(new SurveySessionAnswer(surveySessionAnswer));
                    }
                }
            }
        }
        
		public getSurveySessionAnswers(questionId: number): SurveySessionAnswer[] {
			const surveySessionAnswers = this.surveySessionAnswers ? this.surveySessionAnswers.filter((surveySessionAnswer) => {
				return surveySessionAnswer.questionId === questionId;
			}) : [];

			return surveySessionAnswers;
		}

		public isSurveySessionAnswer(questionId: number, answerId: number): boolean {
			const matches = this.surveySessionAnswers.filter((surveySessionAnswer) => {
				return surveySessionAnswer.questionId === questionId && surveySessionAnswer.answerId === answerId;
			});

			return matches && matches.length > 0;
		}

		public setSurveySessionAnswers(questionId: number, answerIds: number[], answerValue: string): void {
			this.surveySessionAnswers = this.surveySessionAnswers.filter((surveySessionAnswer: SurveySessionAnswer) => {
				return surveySessionAnswer.questionId !== questionId;
			});

			answerIds.forEach((answerId) => {
				const surveySessionAnswer = new SurveySessionAnswer(<ISurveySessionAnswer>{
					questionId: questionId,
					answerId: answerId,
					answerValue: answerValue
				});

				this.surveySessionAnswers.push(surveySessionAnswer);
			});
		}
    }
}